/* eslint-disable import/order */
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { userSegmentationRoute } from '@jira/router-routes__user-segmentation-routes/src/userSegmentationRoute.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { UserSegmentation, LazyUserSegmentation } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const userSegmentationRouteEntry: Route = createEntry(userSegmentationRoute, () => ({
	ufoName: 'user-segmentation',
	// eslint-disable-next-line no-restricted-syntax
	component: UserSegmentation,
	layout: chromelessLayout,
	forPaint: [LazyUserSegmentation],
	resources: [...jiraSpaResources()],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
